import React from "react";
import styles from "./DownloadAppAccordianContent.module.scss";
import classnames from "classnames";
import platform from "platform";

const DownloadAppAccordianContent: React.FC = () => {
    const isMac = React.useMemo(() => {
        return platform.os?.family === "OS X";
    }, []);

    return (
        <>
            <div>
                First thing&apos;s first. We need to install the desktop app so
                that we can control Blender from your computer.{" "}
                <b>Press the download link below to download Blender.</b>
            </div>
            {isMac ? (
                <a
                    id="downloadForMac"
                    className={classnames(
                        "btn btn-secondary btn-sm",
                        styles.downloadButton
                    )}
                    href="https://agora.anthonydito.com/mac/Rend A Hand.dmg"
                >
                    Download for Mac
                </a>
            ) : (
                <a
                    id="downloadForWindows"
                    className={classnames(
                        "btn btn-secondary btn-sm",
                        styles.downloadButton,
                        styles.windowsButton
                    )}
                    href="https://agora.anthonydito.com/win/Setup%20Rend%20A%20Hand.exe"
                >
                    Download for Windows
                </a>
            )}
        </>
    );
};

export default DownloadAppAccordianContent;
